module.exports = __webpack_public_path__ + "static/media/skincare-prod5.803db6fa.png";